import {
  IDeletedAction,
  ILoadCategoriesAction,
  ILoadDetailedMappings,
  ISavedMappings,
  ISetAgencyAction,
  ISetDuplicateObject,
  ISetWicMappingsData,
  ISetWicMappingsErrorAction,
  IWicMappingsAction,
  IWicMappingsState,
} from './types';
import {
  DETAILED_MAPPING_LOADED,
  ERROR_DETAILED_MAPPINGS,
  ERROR_DATA_SUBCATEGORIES,
  ERROR_DATA_MAPPINGS,
  LOAD_MAPPINGS,
  LOAD_DETAILED_MAPPING,
  LOAD_SUB_CATEGORIES,
  MAPPINGS_LOADED,
  RESET,
  RESET_MAPPINGS,
  SET_AGENCY,
  SUB_CATEGORIES_LOADED,
  CLOSE_DIALOG,
  SAVED_MAPPINGS,
  DELETED_ITEMS,
  SET_DUPLICATED_KEY_OBJECT,
} from './actionTypes';

export const initialState: IWicMappingsState = {
  duplicateMessageObject: null,
  errorDetailedMappings: null,
  errorSubCategories: null,
  errorMappings: null,
  syncingCategories: false,
  syncingMappings: false,
  syncingDetailedMappings: false,
  categoriesAndSubCategories: {},
  mappings: [],
  lastPage: true,
  currentAgency: '',
  warningDialogOpen: false,
  detailedMappings: {},
  dialogShown: {},
};

export const reducer = (
  state: IWicMappingsState = initialState,
  action: IWicMappingsAction
): IWicMappingsState => {
  switch (action.type) {
    case LOAD_SUB_CATEGORIES:
      return {
        ...state,
        syncingCategories: true,
        errorSubCategories: null,
      };
    case SUB_CATEGORIES_LOADED:
      return {
        ...state,
        syncingCategories: false,
        categoriesAndSubCategories: {
          ...state.categoriesAndSubCategories,
          [(action as ILoadCategoriesAction).payload.stateIdentifierCode]: (
            action as ILoadCategoriesAction
          ).payload.data,
        },
        errorSubCategories: null,
      };
    case DETAILED_MAPPING_LOADED:
      return {
        ...state,
        syncingDetailedMappings: false,
        detailedMappings: {
          ...state.detailedMappings,
          [(action as ILoadDetailedMappings).payload.upcOrPluCode]: (
            action as ILoadDetailedMappings
          ).payload.data,
        },
      };
    case LOAD_MAPPINGS:
      return {
        ...state,
        syncingMappings: true,
        errorMappings: null,
      };
    case MAPPINGS_LOADED:
      return {
        ...state,
        syncingMappings: false,
        mappings: (action as ISetWicMappingsData)?.payload?.mappingsData || [],
        lastPage: !!(action as ISetWicMappingsData)?.payload?.lastPage,
        warningDialogOpen:
          !(action as ISetWicMappingsData)?.payload?.lastPage &&
          !state.dialogShown[state.currentAgency],
      };
    case LOAD_DETAILED_MAPPING:
      return {
        ...state,
        syncingDetailedMappings: true,
        errorDetailedMappings: null,
      };
    case SAVED_MAPPINGS:
      return {
        ...state,
        mappings: state.mappings.map((item) => {
          if (item.upcOrPluCode === (action as ISavedMappings).payload) {
            return { ...item, isMapped: true };
          }
          return item;
        }),
      };
    case DELETED_ITEMS:
      let newMappings = state.mappings;
      const newMappedItems = state.detailedMappings[
        (action as IDeletedAction).payload.upcOrPluCode
      ].filter((mappedItem) => {
        return !(action as IDeletedAction).payload.itemsToDelete.includes(
          mappedItem.mappedItemCode
        );
      });
      if (newMappedItems.length === 0) {
        newMappings = state.mappings.map((item) => {
          if (item.upcOrPluCode === (action as IDeletedAction).payload.upcOrPluCode) {
            return { ...item, isMapped: false };
          }
          return item;
        });
      }
      return {
        ...state,
        syncingDetailedMappings: false,
        detailedMappings: {
          ...state.detailedMappings,
          [(action as IDeletedAction).payload.upcOrPluCode]: newMappedItems,
        },
        mappings: newMappings,
      };
    case ERROR_DATA_SUBCATEGORIES:
      return {
        ...state,
        syncingCategories: false,
        errorSubCategories: (action as ISetWicMappingsErrorAction).payload,
      };
    case ERROR_DATA_MAPPINGS:
      return {
        ...state,
        syncingMappings: false,
        errorMappings: (action as ISetWicMappingsErrorAction).payload,
      };
    case ERROR_DETAILED_MAPPINGS:
      return {
        ...state,
        syncingDetailedMappings: false,
        errorDetailedMappings: (action as ISetWicMappingsErrorAction).payload,
      };
    case RESET_MAPPINGS:
      return {
        ...state,
        mappings: [],
      };
    case SET_AGENCY:
      return {
        ...state,
        currentAgency: (action as ISetAgencyAction).payload,
        detailedMappings: {},
      };
    case RESET:
      return initialState;
    case SET_DUPLICATED_KEY_OBJECT:
      return {
        ...state,
        duplicateMessageObject: (action as ISetDuplicateObject).payload,
      };
    case CLOSE_DIALOG:
      return {
        ...state,
        warningDialogOpen: false,
        dialogShown: {
          ...state.dialogShown,
          [state.currentAgency]: true,
        },
      };
    default:
      return state;
  }
};
